import { render, staticRenderFns } from "./liveDetailsr.vue?vue&type=template&id=115b6aa4&"
import script from "./liveDetailsr.vue?vue&type=script&lang=js&"
export * from "./liveDetailsr.vue?vue&type=script&lang=js&"
import style0 from "./liveDetailsr.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports